<script>
  import { format } from 'svelte-i18n';

  import { Clipboard } from '@client/components/clipboard';
  import { Icon } from '@client/components/icon';

  export let text;

  let copying = false;

  const copyText = (copyFn) => {
    copying = true;
    copyFn(text);

    setTimeout(() => {
      copying = false;
    }, 1000);
  };
</script>

<div class="rule" class:copying>
  <div>
    {#if copying}
      {$format('label.COPIED')}
    {:else}
      {text}
    {/if}
  </div>
  <Clipboard {text} let:copy>
    <div role="button" tabindex="0" on:click|preventDefault={() => copyText(copy)}>
      {#if copying}
        <Icon name="check" />
      {:else}
        <Icon name="copy" />
      {/if}
    </div>
  </Clipboard>
</div>

<style lang="scss" src="./rule-block.scss"></style>
